export default __webpack_public_path__ + "static/media/ModalImage15.ad90beca.PNG";